import { t } from "../../i18n";

export const calculateDynamicDomain = (data, fieldName, marginPercent = 20) => {
  if (!Array.isArray(data) || data.length === 0) {
    return [0, 10]; // 문제 있으면 기본값 반환
  }

  // 해당 필드의 모든 값 추출 (null/undefined 제외)
  const values = data
    .map((item) => item[fieldName])
    .filter((val) => val != null && !isNaN(val));

  if (values.length === 0) {
    return [0, 10]; // 기본값
  }

  // 최대값, 최솟값 계산
  const min = Math.min(...values);
  const max = Math.max(...values);

  // 최솟값이 0이면 0을 유지, 아니면 마진(30%) 적용
  const minWithMargin =
    min === 0 ? 0 : min - (Math.abs(min) * marginPercent) / 100;
  const maxWithMargin = max + (Math.abs(max) * marginPercent) / 100;

  // 특정 필드는 음수 방지 (강수량, 풍속 등)
  const nonNegativeFields = ["precipitation", "windSpeed"];
  const finalMin = nonNegativeFields.includes(fieldName)
    ? Math.max(0, minWithMargin) // 강수량과 풍속은 0 이하 방지
    : minWithMargin; // 기온은 음수 허용

  // 소수점 1자리로 반올림
  return [Math.round(finalMin * 10) / 10, Math.round(maxWithMargin * 10) / 10];
};

// 2. 여러 필드의 도메인을 한 번에 계산하는 함수
export const calculateMultipleDomains = (data, fields, marginPercent = 20) => {
  const domains = {};

  fields.forEach((field) => {
    domains[field] = calculateDynamicDomain(data, field, marginPercent);
  });

  return domains;
};

// 병해충(count) 단위 처리. 툴팁에 붙는 문구라 부를 때마다 현재 언어로 만든다.
export const formatCountUnit = (value) => {
  const n = Number(value);
  return t("data.unit.count", { count: isFinite(n) ? n : 0 });
};

// 전체 단위 처리 (NDVI / 기후 / 병해충)
export const getUnitForKey = (key, value) => {
  const k = key.toLowerCase();

  // NDVI: 단위 없음
  if (k === "ndvi") return "";

  // 기온 / 습도 / 강수량 / 풍속 → 자동 할당
  if (k.includes("temp") || k.includes("temperature")) return "°C";
  if (k.includes("humid") || k.includes("humidity")) return "%";
  if (k.includes("rain") || k.includes("precip") || k.includes("rainfall"))
    return "mm";
  if (k.includes("wind")) return "m/s";

  // 병해충 관련 → count / counts
  if (
    k.includes("pest") ||
    k.includes("insect") ||
    k.includes("disease") ||
    k.includes("bug")
  ) {
    return formatCountUnit(value);
  }

  // 모르면 단위 없음
  return "";
};
